import PropTypes from "prop-types";

export default function Logo(props) {
	const logo = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 23 27"
			width={props.size}
			height={props.size}
			fill={props.color}
			aria-label={props.logoAlt}
		>
			<g id="T-logo-black" transform="translate(-92 -572)">
				<rect
					id="Rectangle_4626"
					data-name="Rectangle 4626"
					width="23"
					height="27"
					transform="translate(92 572)"
					fill="none"
				/>
				<path
					id="T_logo_rgb_k"
					d="M5.4,17.82H0v-5.4H5.4ZM0,0V9.18H1.62V8.91c0-4.32,2.43-7.02,7.02-7.02h.27V21.33c0,2.7-1.08,3.78-3.78,3.78H4.32V27H18.36V25.11h-.81c-2.7,0-3.78-1.08-3.78-3.78V1.89h.27c4.59,0,7.02,2.7,7.02,7.02v.27h1.62V0ZM17.28,17.82h5.4v-5.4h-5.4Z"
					transform="translate(92 572)"
				/>
			</g>
		</svg>
	);

	if (props.disabledLink) {
		return <>{logo}</>;
	}

	return (
		<a href="/mass-orders" aria-label={props.homeLinkAlt}>
			{logo}
		</a>
	);
}

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	size: PropTypes.number,
	color: PropTypes.string,
	logoAlt: PropTypes.string,
	homeLinkAlt: PropTypes.string
};

Logo.defaultProps = {
	disabledLink: false,
	size: 24,
	color: "#ffffff",
	logoAlt: "Telekom Logo",
	homeLinkAlt: "Go to mass orders"
};
